import React from 'react';
import ReportPageV2 from '../components/report_v2/ReportPageV2';

export default function ReportPage() {
  return <ReportPageV2 />;
}
